import { ModalTypes } from 'Constants/modalTypes';

export const DRAW_MODAL = 'DRAW_MODAL';
export const REMOVE_MODAL = 'REMOVE_MODAL';

export interface ModalState {
  modalType?: ModalTypes;
  modalProps: any;
}

interface DrawModalAction {
  type: typeof DRAW_MODAL;
  modal: ModalTypes;
  props?: any;
}

interface RemoveModalAction {
  type: typeof REMOVE_MODAL;
}

export type ModalActions = DrawModalAction | RemoveModalAction;
